import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const MicrophoneIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 18"
    fill="none"
    {...props}
  >
    <Path d="M2.5 6.75V9.75C2.5 11.9591 4.29086 13.75 6.5 13.75H8M13.5 6.75V9.75C13.5 11.9591 11.7091 13.75 9.5 13.75L8 13.75M8 13.75V16.75M8 16.75H5.5M8 16.75H10.5M6.5 11.75L9.5 11.75C10.6046 11.75 11.5 10.8546 11.5 9.75V2.75C11.5 1.64543 10.6046 0.750002 9.5 0.750002L6.5 0.750001C5.39543 0.75 4.5 1.64543 4.5 2.75V9.75C4.5 10.8546 5.39543 11.75 6.5 11.75Z" stroke={color} strokeWidth="1.5" />
  </Svg>
);

MicrophoneIcon.displayName = 'MicrophoneIcon';
